import React, {Component, useState} from "react";
import styled, {css} from "styled-components";
import {Button} from "primereact/button";
import {Calendar} from "primereact/calendar";
import {Checkbox} from "primereact/checkbox";
import {Dropdown} from "primereact/dropdown";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css'
import {Slider} from 'primereact/slider';

import dayjs from "dayjs";
import Papa from "papaparse";
import {axiosInstance} from "../../utilities/AxiosConfig";
import {notify} from "../toast";
import {InputText} from "primereact/inputtext";

export function WorkerComponent({worker, setWorker, month, setMonth, ph, setPh, workerList, handleReport, loading, setLoading}) {

    const [file, setFile] = useState("");
    const allowedExtensions = ["csv"];
    const [error, setError] = useState("");
    const [workerAll, setWorkerAll] = useState(false);
    const [monthAll, setMonthAll] = useState(false);
    // This function will be called when
    // the file input changes
    const [fileNames, setFileNames] = useState()
    const handleFileChange = (e) => {
        setError("");

        // Check if user has entered the file
        if (e.target.files.length) {
            setFileNames(e.target.files[0].name);
            const inputFile = e.target.files[0];

            // Check the file extensions, if it not
            // included in the allowed extensions
            // we show the error
            const fileExtension =
                inputFile?.type.split("/")[1];
            if (
                !allowedExtensions.includes(fileExtension)
            ) {
                setError("Please input a csv file");
                return;
            }

            // If input type is correct set the state
            setFile(inputFile);
        }
    };
    const handleWorker = (e) => {

        const worker = workerList.find(it => it.name === e.value);
        setWorker(worker);


    }
    const handleParse = () => {

        // If user clicks the parse button without
        // a file we show a error
        if (!file) return alert("Enter a valid file");

        // Initialize a reader which allows user
        // to read any file or blob.
        const reader = new FileReader();

        // Event listener on reader when the file
        // loads, we parse it and set the data.
        reader.onload = async ({target}) => {
            const csv = Papa.parse(target.result, {
                header: true,
            });
            const parsedData = csv?.data;
            const rows = Object.keys(parsedData[0]);

            const columns = Object.values(parsedData[0]);
            const res = rows.reduce((acc, e, i) => {
                return [...acc, [[e], columns[i]]];
            }, []);
            let result = []

            parsedData.forEach(e => {
                if (e[Object.keys(e)[0]] !== "") {
                    result.push(e)
                }
            })
            const body = result.map(it => {
                const t1 = it["Time"].split("/")
                const t2 = t1[2].split(" ")
                const dt = stf(t1[0]) + "-" + stf(t1[1]) + "-" + t2[0]
                const t3 = t2[1].split(":")
                const t = stf(t3[0]) + ":" + stf(t3[1]) + ":00"

                return {
                    workerId: parseInt(it["Person ID"]),
                    name: it["Name"],
                    date: dt,
                    time: t,
                }
            })
            setLoading(true)
            await axiosInstance.post("/attendance/", body).then(res => {
                notify("Uploaded", "success")
                setFileNames("")
            }).catch(e => {
                    notify(e.message, "error")
                }
            ).finally(
                setLoading(false)
            )
        };
        reader.readAsText(file);
    };
    return (
        <div className="card flex container justify-content-center align-content-center w-full pt-9">
            <div className="container flex flex-column justify-content-center align-items-center">
                <Group4 className="mb-2">
                    <Rect></Rect>
                    <div className="flex flex-row justify-content-center align-items-center">
                        <label
                            htmlFor="csvInput"
                            style={{display: "block"}}
                        >
                            Enter Employee Data
                        </label>
                        <input

                            onChange={handleFileChange}
                            id="csvInput"
                            name="file"
                            type="File"
                            style={{
                                height: 56,
                                width: 100,
                                position: "absolute",
                                left: 50,
                                top: 60,
                            }}
                        ></input>
                        <div style={{
                            height: 56,
                            width: 150,
                            position: "absolute",
                            left: 40,
                            top: 87,
                        }}>{fileNames}</div>
                        <UploadWorkerFile>Upload Worker File</UploadWorkerFile>
                        <Button
                            style={{
                                height: 36,
                                width: 100,
                                position: "absolute",
                                left: 45,
                                top: 121,
                                borderRadius: 51,
                                shadowRadius: 0,
                                backgroundColor: "rgba(243,182,182,1)",
                                borderWidth: 0,
                                borderColor: "#000000",
                                borderStyle: "dotted",

                            }}
                            onClick={handleParse}
                            label="Proceed"
                        ></Button>
                    </div>
                </Group4>
                <Group3>
                    <Rect2></Rect2>
                    <Group2>
                        <Checkbox
                            inputId="c1"
                            style={{
                                height: 40,
                                width: 90,
                                position: "absolute",
                                left: 0,
                                top: 18
                            }}
                            checked={monthAll}
                            onChange={(e) => {
                                setMonth(e.checked ? new Date("2000-01-01") : new Date());
                                setWorkerAll(e.checked ? true : workerAll)
                                setWorker({name: e.checked ? "ALL" : worker.name, id: e.checked ? 0 : worker.id});
                                setMonthAll(e.checked);
                            }}
                        />
                        <label htmlFor="c1" className="ml-4 mt-3">All</label>
                        <EnterMonth>Enter Month:</EnterMonth>
                        <Calendar value={month} onChange={(e) => {
                            setMonth(e.value);
                        }}
                                  disabled={monthAll}
                                  view="month" dateFormat="mm/yy" selectionMode={"single"}
                                  style={{
                                      height: 43,
                                      width: 192,
                                      position: "absolute",
                                      left: 11,
                                      top: 41,
                                      borderWidth: 0,
                                      borderColor: "#000000",
                                      borderStyle: "solid",

                                  }}
                        ></Calendar>

                        <InputText value={ph} onChange={(e) => setPh(e.target.value)}
                                   style={{
                                       width: 80,
                                       height: 40,
                                       position: "absolute",
                                       left: 60,
                                       top: 90,
                                       borderWidth: 0,
                                       borderColor: "#000000",
                                       borderStyle: "solid",

                                   }}
                        />
                        <Slider value={ph} id="s1" style={{
                            width: 192,
                            position: "absolute",
                            left: 11,
                            top: 140,
                            borderWidth: 0,
                            borderColor: "#000000",
                            borderStyle: "solid",

                        }} onChange={(e) => setPh(e.value)}/>
                        <label htmlFor="s1" style={{
                            height: 40,
                            width: 192,
                            position: "absolute",
                            left: 40,
                            top: 142
                        }}>Public Holidays</label>
                        <Workers>Workers:</Workers>
                        <Checkbox
                            inputId="c2"
                            style={{
                                height: 40,
                                width: 90,
                                position: "absolute",
                                left: 0,
                                top: 165
                            }}
                            checked={workerAll}
                            onChange={(e) => {
                                setWorker({name: e.checked ? "ALL" : "", id: e.checked ? 0 : worker.id});
                                setWorkerAll(e.checked);
                            }}
                        ></Checkbox>
                        <label htmlFor="c1" className="ml-4 mt-2" style={{
                            height: 40,
                            width: 90,
                            position: "absolute",
                            left: 0,
                            top: 155
                        }}>All</label>
                        <Dropdown value={worker.name} options={workerList.map(it => it.name)} onChange={(e) => {
                            handleWorker(e);
                        }}
                                  disabled={worker.name === "ALL" || monthAll}
                                  placeholder="Select a Worker"
                                  style={{
                                      height: 43,
                                      width: 192,
                                      position: "absolute",
                                      left: 11,
                                      top: 185,

                                  }}
                        ></Dropdown>


                    </Group2>
                    <Button
                        className="pi pi-print  rounded outlined raised rounded "
                        onClick={() => {
                            handleReport();
                        }}

                        style={{
                            height: 56,
                            width: 56,
                            position: "absolute",
                            top: 260,
                            left: 96
                        }}
                    ></Button>
                </Group3>
            </div>
        </div>
    );
}

const stf = (t) => {
    if (t.length === 1) {
        return "0" + t
    }
    return t
}
const Container = styled.div`
    width: 247px;
    height: 542px;
    position: relative;
    display: flex;
`;

const Group4 = styled.div`

    width: 187px;
    height: 177px;
    position: relative;
    display: flex;
`;

const Rect = styled.div`
    top: 0px;
    left: 0px;
    width: 187px;
    height: 177px;
    position: absolute;
    background-color: #E6E6E6;
    border-radius: 24px;
    box-shadow: 3px 3px 22px 0.33px rgba(0, 0, 0, 1);
`;

const UploadWorkerFile = styled.span`
    font-family: serif;
    top: 22px;
    left: 35px;
    position: absolute;
    font-style: normal;
    font-weight: 400;
    color: #121212;
`;

const Group3 = styled.div`
    width: 247px;
    height: 330px;
    position: relative;
    display: flex;
`;

const Rect2 = styled.div`
    top: 1px;
    left: 1px;
    width: 247px;
    height: 330px;
    position: absolute;
    background-color: #E6E6E6;
    border-radius: 27px;
    box-shadow: 3px 3px 22px 1px rgba(0, 0, 0, 1);
`;

const Group2 = styled.div`
    top: 26px;
    left: 18px;
    width: 203px;
    height: 84px;
    position: absolute;
    display: flex;
`;

const EnterMonth = styled.span`
    font-family: serif;
    top: 14px;
    left: 114px;
    position: absolute;
    font-style: normal;
    font-weight: 400;
    color: #121212;
`;

const Group = styled.div`
    top: 149px;
    left: 18px;
    width: 203px;
    height: 72px;
    position: absolute;
    display: flex;
`;

const Workers = styled.span`
    font-family: sans-serif;
    top: 160px;
    left: 138px;
    position: absolute;
    font-style: normal;
    font-weight: 400;
    color: #121212;
`;

